import Immutable from 'seamless-immutable';
import { createActions, createReducer } from 'reduxsauce';

const INITIAL_STATE = Immutable({
  loading: false,
  result: {},
  smsResult: {},
  retirement: {},
  retrievingRetirement: true,
  loadingSmsSent: false,
  error: false,
});

export const { Creators, Types } = createActions({
  calculateRetirementRequested: ['retirementData'],
  calculateRetirementSuccess: ['result'],
  calculateRetirementError: ['error'],

  retrieveRetirementRequested: ['uuid'],
  retrieveRetirementSuccess: ['result'],
  retrieveRetirementError: ['error'],

  sendSMSRequested: ['uuid'],
  sendSMSSuccess: ['result'],
  sendSMSError: ['error'],

  verifyCodeRequested: ['data'],
  verifyCodeSuccess: ['result'],
  verifyCodeError: ['error'],
});

export const Selectors = {
  // Selector will be here...
};

export const Reducer = createReducer(INITIAL_STATE, {
  [Types.SEND_SMS_REQUESTED]: state => state.merge({ loadingSmsSent: true }),
  [Types.SEND_SMS_SUCCESS]: (state, { result }) => state.merge({ smsResult: result, loadingSmsSent: false }),
  [Types.SEND_SMS_ERROR]: state => state.merge({ loadingSmsSent: false, error: true }),
  [Types.RETRIEVE_RETIREMENT_REQUESTED]: state => state.merge({ retrievingRetirement: true }),
  [Types.RETRIEVE_RETIREMENT_SUCCESS]: (state, { result }) => state.merge({ retirement: result, retrievingRetirement: false }),
  [Types.RETRIEVE_RETIREMENT_ERROR]: (state, object) => state.merge({ retrievingRetirement: false, error: true, result: object }),
  [Types.CALCULATE_RETIREMENT_REQUESTED]: state => state.merge({ loading: true }),
  [Types.CALCULATE_RETIREMENT_SUCCESS]: (state, object) => state.merge({ loading: false, result: object }),
  [Types.CALCULATE_RETIREMENT_ERROR]: state => state.merge({ loading: false, error: true }),
  [Types.VERIFY_CODE_REQUESTED]: state => state.merge({ loading: true }),
  [Types.VERIFY_CODE_SUCCESS]: (state, { result }) => state.merge({ result, loading: false }),
  [Types.VERIFY_CODE_ERROR]: state => state.merge({ loading: false, error: true }),
});
